export function getdata(){
	var obj = {
		headData: [{
				title: "项目",
				prop:'title',
				width: "250px",
				custom: true,
				
			},
			{
				title: "本期金额",
				prop: "cwbbwzx_1_x_1",
				custom: true,
				width: "200px",
				

			},
			{
				title:'上期金额',
				prop:'cwbbwzx_1_x_2',
				width: "200px",
				custom: true,
				
			},
		],
		tableData: [{
				title: "一、营业收入",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_1_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_1_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},
			{
				title: "减：营业成本",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_2_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_2_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "税金及附加",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_3_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_3_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "销售费用",
				grade: "3",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_4_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_4_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "管理费用",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_5_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_5_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "研发费用",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_6_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_6_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "财务费用",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_7_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_7_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "其中：利息费用",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_8_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_8_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "利息收入",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_9_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_9_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "加：其他收益",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_10_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_10_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "投资收益（损失以“-”号填列）",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_11_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_11_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "其中：对联营企业和合营企业的投资收益",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_12_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_12_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "公允价值变动收益（损失以“-”号填列）",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_13_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_13_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "资产减值损失（损失以“-”号填列）",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_14_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_14_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "资产处置收益（损失以“-”号填列）",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_15_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_15_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "二、营业利润（亏损以“-”号填列）",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_16_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_16_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "加：营业外收入",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_17_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_17_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "减：营业外支出",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_18_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_18_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "三、利润总额（亏损总额以“-”号填列）",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_19_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_19_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "减：所得税费用",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_20_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_20_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "四、净利润（净亏损以“-”号填列）",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_21_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_21_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "（一）持续经营净利润（净亏损以“-”号填列）",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_22_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_22_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "（二）终止经营净利润（净亏损以“-”号填列）",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_23_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_23_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "五、其他综合收益的税后净额",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_24_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_24_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "（一）不能重分类进损益的其他综合收益",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_25_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_25_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "1．重新计量设定受益计划变动额",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_26_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_26_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "2．权益法下不能转损益的其他综合收益",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_27_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_27_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "（二）将重分类进损益的其他综合收益",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_28_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_28_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "1．权益法下可转损益的其他综合收益",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_29_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_29_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "2.可供出售金融资产公允价值变动损益",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_30_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_30_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "3.持有至到期投资重分类可供出售金融资产损益",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_31_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_31_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "4. 现金流量套期损益的有效部分",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_32_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_32_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "5.外币财务报表折算差额",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_33_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_33_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "六、综合收益总额",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_34_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_34_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "七、每股收益：",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_35_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_35_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "（一）基本每股收益",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_36_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_36_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "（二）稀释每股收益",
				disabledcwbbwzx_1_x_1:false,
				disabledcwbbwzx_1_x_2:false,
				cwbbwzx_1_x_1: {
					cellCode:"cwbbwzx_1_37_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_1_x_2: {
					cellCode:"cwbbwzx_1_37_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			}
		]
	}
	return obj
} 

